import { render, staticRenderFns, recyclableRender, components } from "./previewProduct.vue?vue&type=template&id=150e5864&"
var renderjs
import script from "./previewProduct.vue?vue&type=script&lang=js&"
export * from "./previewProduct.vue?vue&type=script&lang=js&"
import style0 from "./previewProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/previewProduct/previewProduct.vue"
export default component.exports